import React, {useEffect, useState} from 'react'
import {Row, Col, Tabs, Card, Button, Tooltip} from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'

import { connect } from 'react-redux'

import QeyriBudce from './QeyriBudce'
import Dxa from './Dxa'
import Edv from './Edv'

import './index.scss'
import {TabsInfoIco} from "../../../../../modules/CustomIcons";
import {useHistory, useLocation} from "react-router-dom";
import CustomTooltip from "components/Tooltip";
import {getPathnameByIndex} from "../../../../services/helper";
import {checkPermission} from "../../../../services/permission";
import {getCurrentCompany} from "../../../../services/user";
import {useTranslation} from "react-i18next";
import noSelected from "assets/images/noSelectedTransfer.svg";
import {getMessageLists} from "store/actions/home";







const TransferDomestic: React.FC<any> = ({companyData,messageList}) => {

    const language = localStorage.getItem("i18nextLng")


    const [textArray_qbudce,setTextArray_qbudce] = useState([])
    const [textArray_Dxa,setTextArray_Dxa] = useState([])
    const [textArray_edv,setTextArray_edv] = useState([])

    const fetchessageData = async () => {

        let lang_text_qbudce = messageList?.result !== undefined ? (language=="az" ? messageList.result.find(text=> text.messageKey === 'INFO.TR_IPS_OTHER')?.textAZE :
            language=="ru" ?  messageList.result.find(text=> text.messageKey === 'INFO.TR_IPS_OTHER')?.textRU : language=="en" ?  messageList.result.find(text=> text.messageKey === 'INFO.TR_IPS_OTHER')?.textENG :"") : "";
        const array_qbudce =lang_text_qbudce !== null && lang_text_qbudce !== undefined? lang_text_qbudce.split("|") : [];

        let lang_text_dxa = messageList?.result !== undefined ? (language=="az" ? messageList.result.find(text=> text.messageKey === 'INFO.TR_IPS_DXA')?.textAZE :
            language=="ru" ?  messageList.result.find(text=> text.messageKey === 'INFO.TR_IPS_DXA')?.textRU : language=="en" ?  messageList.result.find(text=> text.messageKey === 'INFO.TR_IPS_DXA')?.textENG :"") : "";
        const array_dxa = lang_text_dxa !== null && lang_text_dxa !== undefined ? lang_text_dxa.split("|") : [];

        let lang_text_edv = messageList?.result !== undefined ? (language=="az" ? messageList.result.find(text=> text.messageKey === 'INFO.TR_IPS_VAT')?.textAZE :
            language=="ru" ?  messageList.result.find(text=> text.messageKey === 'INFO.TR_IPS_VAT')?.textRU : language=="en" ?  messageList.result.find(text=> text.messageKey === 'INFO.TR_IPS_VAT')?.textENG :"") : "";
        const array_edv = lang_text_edv !== null && lang_text_edv !== undefined ? lang_text_edv.split("|") : [];

        setTextArray_Dxa(array_dxa);
        setTextArray_qbudce(array_qbudce)
        setTextArray_edv(array_edv)
    };


    useEffect(() => {
        fetchessageData()
    }, [messageList,language])

    const TooltipMessageqbudce= `
    ${
        textArray_qbudce.map((line:any,index:number) => {

            return(

                line.startsWith('http') ?
                    `<a href=${line} key=${index} > ${line} </a>`
                    :
                    `<p key=${index}> ${line} </p>`
            )
        }).join('')
    }
    `

    const TooltipMessageDxa = `
    ${
        textArray_Dxa.map((line:any,index:number) => {

            return(

                line.startsWith('http') ?
                    `<a href=${line} key=${index} > ${line} </a>`
                    :
                    `<p key=${index}> ${line} </p>`
            )
        }).join('')
    }
    `

    const TooltipMessageEdv = `
    ${
        textArray_edv.map((line:any,index:number) => {

            return(

                line.startsWith('http') ?
                    `<a href=${line} key=${index} > ${line} </a>`
                    :
                    `<p key=${index}> ${line} </p>`
            )
        }).join('')
    }
    `
    const {t} = useTranslation()
    const tabInnerData: Array<any> = [
    {
        index: 1,
        title: t("home.nonBUDGET"),
        description : TooltipMessageqbudce,
        content: <QeyriBudce/>,
        path : '/new_transfer/anipay/qbudce',
        permissionKey : 'IPS_OTH',
    },
    {
        index: 2,
        title: t("home.anipaySTA"),
         description : TooltipMessageDxa,
        content: <Dxa/>,
        path : '/new_transfer/anipay/dxa',
        permissionKey : 'IPS_BDG',
    },
    {
        index: 3,
        title: t("home.anipayVAT"),
        description :TooltipMessageEdv,
        content: <Edv/>,
        path : '/new_transfer/anipay/edv',
        permissionKey : 'IPS_VAT',
    }
]

    const { TabPane } = Tabs;
    const history = useHistory();
    const location = useLocation();
    const find_tab=tabInnerData.find(row => row.path.includes(getPathnameByIndex(2)));
    const [tabActiveKey, setTabActiveKey] = useState<number>(find_tab?.index);

    useEffect(() => {
        const find_tab=tabInnerData.find(row => row.path.includes(getPathnameByIndex(2)));

        setTabActiveKey(find_tab?.index);

    }, [location, companyData])

    const tabOnChange = (activeKey) => {
        setTabActiveKey(old_key => activeKey);

        const find_row=tabInnerData.find(row => row.index==activeKey);

        if (find_row){
            history.push(find_row.path);
        }
    };
  return (
    <Row>
      <Col span={24} style={{minWidth: "750px"}}>
          <Tabs
              activeKey={`${tabActiveKey}`}
              onChange={tabOnChange}
              id="transferTab"
              destroyInactiveTabPane={true}
          >

            {tabInnerData &&
              tabInnerData.map((item) => {
                return checkPermission(item.permissionKey) && (
                  <TabPane tab={
                      <span>{item.title}
                          <CustomTooltip
                              title={item.description}
                          >
                              <Button type={'ghost'} className={'transparent'} icon={<TabsInfoIco />} />
                          </CustomTooltip>
                      </span>} key={item.index}>
                    {item.content}
                  </TabPane>
                )
              })}
          </Tabs>
      </Col>
        { tabActiveKey === undefined && <span className={'noSelected'}>{t("newTransfer.noSelectedTransfer")}
            <img src={noSelected}/>
              </span> }
    </Row>
  )
}
const mapDispatchToProps = { getMessageLists }
const mapStateToProps = (state: any) => ({
    companyData: (state.user &&  state.user.companyData.result) ?  state.user.companyData.result.customerNo  : getCurrentCompany(),
    messageList: state.home.messageList,

})

export default connect(mapStateToProps, mapDispatchToProps)(TransferDomestic)
